import { renderCallback } from './auth.js'

// The sign-in link in the email lands on /auth/callback. That is a page of its
// own -- no map, no routing -- because the only thing it does is wait for a
// click: a GET must never sign anyone in, since mail scanners fetch every link
// in an email before a human sees it. The map app is imported lazily so it is
// never even started here.
if (window.location.pathname === '/auth/callback') {
  document.getElementById('map')?.remove()
  const panel = document.getElementById('panel')
  panel.classList.add('panel--callback')

  const token = new URLSearchParams(window.location.search).get('token')

  // Take the token out of the address bar and out of history the moment it is
  // read. It is a bearer credential: left in the URL it sits in plain view on
  // a shared screen and stays in the history of whoever next opens the laptop.
  if (token) window.history.replaceState({}, '', window.location.pathname)

  renderCallback(panel, {
    token,
    onSignedIn: () => window.location.replace('/'),
  })
} else {
  import('./app.js')
}
